module.exports = __webpack_public_path__ + "19a51a3f.png";